import { FormTracking } from "../types";

declare const window: Window & { dataLayer: any };

export const common: FormTracking.Implementation = ({ formId }) => {
  if (typeof window.dataLayer !== "undefined")
    window.dataLayer.push({
      event: "formSubmit",
      formType: formId
    });
};
